import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { NotFoundComponent } from './shared/not-found/not-found.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { DemographicsComponent } from './demographics/demographics.component';
import { MessagesComponent } from './messages/messages.component';
import { PtoRequestComponent } from './pto-request/pto-request.component';
import { PtoHistoryComponent } from './pto-history/pto-history.component';
import { DetailViewComponent } from './detail-view/detail-view.component';
import { MessageBodyComponent } from './messages/message-body/message-body.component';
import { ShiftBidComponent } from './shift-bid/shift-bid.component';
import { ShiftBidOptionsComponent } from './shift-bid-options/shift-bid-options.component';
import { TimeAllocationComponent } from './time-allocation/time-allocation.component';
import { TimeAllocationHistoryComponent } from './time-allocation-history/time-allocation-history.component';

export const RoutePaths = {
  Demographics: 'demographics',
  Schedule: {
    Root: 'schedule',
    Detail: 'detail/:id',
  },
  DetailView: 'detail-view',
  Messages: {
    Root: 'messages',
    Detail: 'messages/detail',
  },
  Pto: {
    Root: 'pto-request',
    History: 'pto-history',
  },
  ShiftBidding: {
    Root: 'shift-bid',
    Options: 'shift-bid-options',
  },
  TimeAllocation: {
    Root: 'time-allocation',
    History: 'time-allocation-history',
  },
}

export const routes: Routes = [
  {
    path: RoutePaths.Demographics,
    component: DemographicsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.Schedule.Root,
    component: ScheduleComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: RoutePaths.Schedule.Detail,
        component: DetailViewComponent,
      },
    ],
  },
  {
    path: RoutePaths.DetailView,
    component: DetailViewComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.Messages.Root,
    component: MessagesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.Messages.Detail,
    component: MessageBodyComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.Pto.Root,
    component: PtoRequestComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.Pto.History,
    component: PtoHistoryComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.ShiftBidding.Root,
    component: ShiftBidComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.ShiftBidding.Options,
    component: ShiftBidOptionsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.TimeAllocation.Root,
    component: TimeAllocationComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutePaths.TimeAllocation.History,
    component: TimeAllocationHistoryComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '',
    redirectTo: RoutePaths.Demographics,
    pathMatch: 'full',
  },
  {
    path: '**',
    component: NotFoundComponent,
  },

];
